import {
  EXPORT_STATEMENT_BALANCE,
  EXPORTED_STATEMENT_BALANCE,
  FETCH_STATEMENT_BALANCE,
  LIST_STATEMENT_BALANCE
} from "./types";

const init = {
  isLoading: false,
  filter: {},
  summary: {},
  list: [],
  page: 1,
  size: 10,
  totals: 0
};

export default (state = init, {type, payload}) => {
  switch (type) {
    case EXPORT_STATEMENT_BALANCE:
      return {
        ...init,
        filter: payload,
        isLoading: true
      };
    case FETCH_STATEMENT_BALANCE:
      return {
        ...state,
        filter: payload,
        isLoading: true
      };
    case LIST_STATEMENT_BALANCE:
      return {
        ...state,
        isLoading: false,
        list: payload.data.items,
        summary: payload.data.summary,
        ...payload.paging
      };
    case EXPORTED_STATEMENT_BALANCE:
      return {
        ...state,
        list: payload.data.items,
        summary: payload.data.summary,
        ...payload.paging
      };
    default:
      return state;
  }
}